type HospitalOption = { id: number; name: string };

type EmployeeNetworkHospitalsFieldProps = {
  hospitals: HospitalOption[];
  selectedIds: number[];
  primaryId: number | null;
  emptyHint?: string;
  onChange: (next: { selectedIds: number[]; primaryId: number | null }) => void;
};

export function EmployeeNetworkHospitalsField({
  hospitals,
  selectedIds,
  primaryId,
  emptyHint = "Aucun hôpital disponible — sélectionnez une entreprise / vérifiez les conventions.",
  onChange,
}: EmployeeNetworkHospitalsFieldProps) {
  const toggle = (id: number, checked: boolean) => {
    const nextSelected = checked
      ? Array.from(new Set([...selectedIds, id]))
      : selectedIds.filter((x) => x !== id);
    let nextPrimary = primaryId;
    if (!checked && primaryId === id) {
      nextPrimary = nextSelected[0] ?? null;
    }
    if (checked && (nextPrimary === null || !nextSelected.includes(nextPrimary))) {
      nextPrimary = id;
    }
    onChange({ selectedIds: nextSelected, primaryId: nextPrimary });
  };

  return (
    <div className="md:col-span-2">
      <p className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        Hôpitaux affectés (réseau)
      </p>
      <p className="mb-2 text-xs text-muted">
        Cochez un ou plusieurs hôpitaux du réseau conventionnel. L’hôpital{" "}
        <strong>principal</strong> sert au calcul du forfait.
      </p>
      <div className="max-h-56 overflow-y-auto rounded-lg border border-border p-2">
        {hospitals.length === 0 ? (
          <p className="px-1 py-2 text-sm text-muted">{emptyHint}</p>
        ) : (
          hospitals.map((hospital) => {
            const checked = selectedIds.includes(hospital.id);
            const isPrimary = primaryId === hospital.id;
            return (
              <div
                key={hospital.id}
                className="flex items-center gap-2 border-b border-border/60 py-1.5 last:border-0"
              >
                <input
                  type="checkbox"
                  className="h-4 w-4 accent-primary"
                  checked={checked}
                  onChange={(e) => toggle(hospital.id, e.target.checked)}
                  id={`eh_${hospital.id}`}
                />
                <label htmlFor={`eh_${hospital.id}`} className="flex-1 text-sm text-foreground">
                  {hospital.name}
                </label>
                <label className="flex items-center gap-1 text-xs text-muted whitespace-nowrap">
                  <input
                    type="radio"
                    name="primary_hospital"
                    className="accent-primary"
                    disabled={!checked}
                    checked={isPrimary}
                    onChange={() =>
                      onChange({ selectedIds, primaryId: hospital.id })
                    }
                  />
                  Principal
                </label>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
